import React from "react";
import { Link } from "react-router-dom";
import { Quote } from "lucide-react";
import { formatINR } from "@/lib/format";

export function PageHeader({ crumb, title, intro }) {
  return (
    <header className="container-page pt-14 pb-8 md:pt-20 md:pb-10 animate-fade-up">
      {crumb && (
        <div className="label-caps mb-4">
          <Link to="/" className="hover:text-earth transition-colors">Home</Link>
          <span className="mx-2 text-earth/30">/</span>
          <span className="text-earth">{crumb}</span>
        </div>
      )}
      <h1 className="text-4xl md:text-6xl text-earth leading-tight" style={{ fontWeight: 600, letterSpacing: "-0.02em" }}>
        {title}
      </h1>
      {intro && <p className="mt-5 text-lg md:text-xl text-earth/70 max-w-2xl">{intro}</p>}
    </header>
  );
}

export function SectionLabel({ children }) {
  return <p className="label-caps mb-3">{children}</p>;
}

export function TestimonialCard({ t }) {
  return (
    <div className="bg-surface-card p-8 rounded-lg border hairline flex flex-col gap-4 h-full" data-testid="testimonial-card">
      <Quote className="text-gold" size={40} strokeWidth={1.5} />
      <p className="text-xl text-earth italic font-display leading-snug flex-1">"{t.quote}"</p>
      {t.story && <p className="text-sm text-earth/60 line-clamp-3">{t.story}</p>}
      <div className="label-caps text-earth/60">{t.name}</div>
    </div>
  );
}

export function ServiceCard({ s }) {
  return (
    <Link
      to={`/services/${s.slug}`}
      className="group bg-surface-card p-7 rounded-lg border hairline flex flex-col hover:border-gold transition-all duration-300 hover:-translate-y-1"
      data-testid={`service-card-${s.slug}`}
    >
      <span className="label-caps text-sage-700" style={{ color: "#5a694f" }}>{s.format}</span>
      <h3 className="text-2xl text-earth mt-2 mb-2 group-hover:text-gold-dark transition-colors">{s.title}</h3>
      <p className="text-earth/70 flex-1 mb-5">{s.shortDescription}</p>
      <div className="flex items-end justify-between pt-4 border-t hairline">
        <div>
          <div className="text-2xl text-earth font-display" style={{ fontWeight: 600 }}>{formatINR(s.price)}</div>
          <div className="text-xs text-earth/50">{s.durationLabel}</div>
        </div>
        <span className="text-sm font-semibold text-gold-dark group-hover:translate-x-1 transition-transform">Learn more →</span>
      </div>
    </Link>
  );
}

export function Chip({ children }) {
  return (
    <span className="inline-block text-xs font-semibold px-3 py-1 rounded-full" style={{ backgroundColor: "rgba(168,184,154,0.25)", color: "#4a5a3e" }}>
      {children}
    </span>
  );
}

export function Loader() {
  return (
    <div className="flex justify-center py-24">
      <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
